import { render, staticRenderFns } from "./PePrompt.vue?vue&type=template&id=2bb0da68&"
import script from "./PePrompt.vue?vue&type=script&lang=js&"
export * from "./PePrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports